/* vc-home-tabs.js — Bestsellers category tabs.
   Real ARIA tabs with arrow-key, Home and End support. Switching swaps the
   grid (the panel cross-fades over 0.3s via CSS) and retargets the
   "View all ..." link, whose label and href travel on the tab button.
   Loaded with defer. */
(function () {
  'use strict';

  function setup(root) {
    if (root.__vcTabs) return;
    var list = root.querySelector('[role="tablist"]');
    if (!list) return;
    root.__vcTabs = true;

    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    var viewAll = root.querySelector('[data-vch-viewall]');
    if (!tabs.length) return;

    function panelFor(tab) {
      var id = tab.getAttribute('aria-controls');
      return id ? root.querySelector('#' + CSS.escape(id)) : null;
    }

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        var p = panelFor(t);
        if (p) {
          p.classList.toggle('is-active', on);
          if (on) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        }
      });

      if (viewAll) {
        var label = tab.getAttribute('data-viewall-label');
        var href = tab.getAttribute('data-viewall-href');
        /* The design shortens this label on phones, so the link holds a long
           and a short span and CSS picks one. Only the long one changes. */
        var long = viewAll.querySelector('[data-vch-viewall-long]');
        if (label) {
          if (long) long.textContent = label;
          else viewAll.textContent = label;
        }
        if (href) {
          viewAll.setAttribute('href', href);
          viewAll.hidden = false;
        } else {
          viewAll.hidden = true;
        }
      }

      /* Newly shown cards still need their reveal hooked up. */
      if (window.VCHome && window.VCHome.observeReveals) {
        var p2 = panelFor(tab);
        if (p2) window.VCHome.observeReveals(p2);
      }

      if (focus) tab.focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        select(tab, false);
      });

      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) {
          e.preventDefault();
          select(next, true);
        }
      });
    });

    /* Honour whichever tab the markup marked selected. */
    var initial = tabs.filter(function (t) {
      return t.getAttribute('aria-selected') === 'true';
    })[0] || tabs[0];
    select(initial, false);
  }

  function initAll(r) {
    (r || document).querySelectorAll('[data-vch-tabs]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
